//import core
import core from "js/site/shared/Core";
import "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

const promises = [new Promise(() => core.init())];

Promise.all(promises).then(loadPlugins());

function loadPlugins() {
  console.log("Plugins loaded");

  $(window).scroll(function () {
    const pageHeading = $("section.page-heading");
    const shrinkIt = pageHeading.height();
    const scroll = $(window).scrollTop();

    if (scroll >= shrinkIt) {
      pageHeading.addClass("fixed-content-title");
    } else {
      pageHeading.removeClass("fixed-content-title");
    }
  });

  const openShareWindowButtons = document.querySelectorAll(
    "a.open-share-window"
  );
  const shareButtons = document.querySelectorAll("a.share-button");

  const url = window.location.href;
  const pageTitle = document.getElementById("page-title").value;

  let shareOnTwitter = `https://twitter.com/share?url=${url}&text=${pageTitle}&via=goztepe`;
  let shareOnFacebook = `https://www.facebook.com/sharer/sharer.php?u=${url}&title=${pageTitle}`;
  let shareOnWhatsapp = `https://api.whatsapp.com/send?text=${url}`;
  let shareOnEmail = `mailto:?subject=${pageTitle}&amp;body=Göztepe resmi sitesinde okumanı istediğim bir içerik buldum.%0D%0D${url}`;

  shareButtons.forEach((btn) => {
    if (btn.classList.contains("share-twitter"))
      btn.dataset.url = shareOnTwitter;

    if (btn.classList.contains("share-facebook"))
      btn.dataset.url = shareOnFacebook;

    if (btn.classList.contains("share-whatsapp")) btn.href = shareOnWhatsapp;

    if (btn.classList.contains("share-mail")) btn.href = shareOnEmail;
  });

  openShareWindowButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const windowWidth = 650,
        windowHeight = 450,
        shareUrl = this.dataset.url,
        shareTitle = e.target.title;

      window.open(
        shareUrl,
        shareTitle,
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${windowWidth},height=${windowHeight},top=${
          (screen.height - windowHeight) / 2
        },left=${(screen.width - windowWidth) / 2}`
      );
    });
  });
}
